var isString = function isString(string) {
    return Object.prototype.toString.call(string) === "[object String]";
};

module.exports = {
    /**
     * 打印log日志
     * @method hysdk.log
     * @category Fusion:Log
     * @description
     * 与 Hy 环境用法、参数格式相同
     */
    log: {
        service: 'Util',
        action: 'h5Log',
        tagname: 'log',
        optHandle: function optHandle(opt) {
            return {
                log: opt
            };
        }
    },
    uelog: false,
    abTest: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/log.js
// module id = 46
// module chunks = 1 4